import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BillPayer from 'web-app/react/entities/bill-payers/model';
import Institution from 'web-app/react/entities/institutions/model';

export const fetchBillPayerData = () => {
    return RESTClient.getAuthenticatedObservable('v2/invoicing/billPayers').map(data => ({
        billPayers: List(data.billPayers).map(BillPayer.fromAPI),
        institutions: List(Object.values(data.institutions)).map(Institution.fromAPI),
    }));
};
